import { render, staticRenderFns } from "./OrderItemDetail.vue?vue&type=template&id=33cf3ac2&scoped=true&"
import script from "./OrderItemDetail.vue?vue&type=script&lang=js&"
export * from "./OrderItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemDetail.vue?vue&type=style&index=0&id=33cf3ac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cf3ac2",
  null
  
)

export default component.exports